import { useEffect, useState } from 'react'
import { Datatrans } from './Datatrans'
import { SaferPay } from './SaferPay'
import { Select } from 'entities/Select'
import { RenderIf } from 'shared/helpers/renderIf'
import { TwoColumnedDiv } from 'entities/TwoColumnedDiv'
import { usePaymentConfigStore } from 'shared/store/paymentSlice'
import { PaymentHealthCheckButton } from 'features/_Buttons/PaymentHealthCheck'
import { useGlobalStore } from 'shared/store/globalSlice'
import { useBranchStore } from '../../shared/store/branchesSlice'
import { getGuid } from 'shared/helpers/getGUID'
import { HSPay } from './HSPay'

// TODO: remove
const TEST_DB_GUID = '9712049c-1325-430f-b0c8-f6d64e5cf9c5'

export const PaymentProviderSelector = () => {
  const updatePaymentProvider = usePaymentConfigStore().updatePaymentProvider
  const loadPaymentConfig = usePaymentConfigStore().loadPaymentConfig
  const paymentConfig = usePaymentConfigStore().paymentConfig
  const branchId = useBranchStore().branchId
  const isCC = useGlobalStore().isCCSelected

  useEffect(() => {
    loadPaymentConfig()
  }, [branchId])

  // TEMPORARY CHECK. HS-Pay is available for test DB only.
  const [guid, setGuid] = useState('')

  useEffect(() => {
    checkGuid()
  }, [])

  const checkGuid = async () => {
    const GUID = await getGuid()
    console.log('🚀 ~ GUID:', GUID)
    setGuid(GUID || '')
  }
  //////////////////////

  return (
    <>
      <TwoColumnedDiv>
        <Select
          label='Payment provider'
          value={
            Boolean(paymentConfig?.paymentOnSite && isCC) ? 0 : paymentConfig?.paymentProviderType
          }
          onChange={value => updatePaymentProvider(value as 1)}
          options={PaymentProviderOptions(isCC, guid)}
        />
      </TwoColumnedDiv>

      <RenderIf
        condition={paymentConfig?.paymentProviderType === 1 && !paymentConfig?.paymentOnSite}
      >
        <Datatrans />
      </RenderIf>
      <RenderIf
        condition={paymentConfig?.paymentProviderType === 2 && !paymentConfig?.paymentOnSite}
      >
        <SaferPay />
      </RenderIf>
      <RenderIf
        condition={paymentConfig?.paymentProviderType === 3 && !paymentConfig?.paymentOnSite}
      >
        <HSPay />
      </RenderIf>
      <RenderIf
        condition={paymentConfig?.paymentProviderType !== 3 && !paymentConfig?.paymentOnSite}
      >
        <TwoColumnedDiv>
          <PaymentHealthCheckButton />
        </TwoColumnedDiv>
      </RenderIf>
    </>
  )
}

// TODO: remove GUID check
const PaymentProviderOptions = (isCC = false, guid = '') => [
  ...(isCC
    ? [
        {
          value: 0,
          label: 'Bezahlung vor Ort'
        }
      ]
    : []),
  {
    value: 1,
    label: 'Datatrans'
  },
  ...(!isCC
    ? [
        {
          value: 2,
          label: 'SaferPay'
        }
      ]
    : []),
  ...(!isCC && guid === TEST_DB_GUID
    ? [
        {
          value: 3,
          label: 'HS-Pay'
        }
      ]
    : [])
]
